export default function CoreValues() {
  const values = [
    {
      icon: 'ri-heart-3-line',
      title: 'We honor great veterinarians',
      description: 'We respect the skill, compassion, and judgment veterinarians bring to every patient and every family.',
      color: 'bg-[#4DB8D4]',
      bgColor: 'bg-[#4DB8D4]/5',
      borderColor: 'border-[#4DB8D4]/20',
    },
    {
      icon: 'ri-fire-line',
      title: 'Passion creates impact',
      description: 'We believe passionate veterinarians can improve lives, build trust, and create meaningful change.',
      color: 'bg-[#0F1F3D]',
      bgColor: 'bg-[#0F1F3D]/5',
      borderColor: 'border-[#0F1F3D]/20',
    },
    {
      icon: 'ri-door-open-line',
      title: 'Access matters',
      description: 'We believe veterinary care should be easier to access and more affordable for more pet owners.',
      color: 'bg-[#2a7a8e]',
      bgColor: 'bg-[#2a7a8e]/5',
      borderColor: 'border-[#2a7a8e]/20',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity comes first',
      description: 'Everything we build should reflect trust, professionalism, and respect for the veterinary profession.',
      color: 'bg-[#1a3a6e]',
      bgColor: 'bg-[#1a3a6e]/5',
      borderColor: 'border-[#1a3a6e]/20',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-gradient-to-b from-white to-[#F8FCFD]">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        
        {/* Section Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-[#4DB8D4]/10 border border-[#4DB8D4]/20 px-4 py-2 rounded-full mb-6">
            <i className="ri-star-line text-[#4DB8D4] text-sm"></i>
            <span className="text-xs font-semibold tracking-widest uppercase text-[#0F1F3D]">
              Our Core Values
            </span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-serif text-[#0F1F3D] leading-tight max-w-3xl mx-auto">
            What We Believe
          </h2>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-2 gap-6">
          {values.map((value, i) => (
            <div
              key={i}
              className={`${value.bgColor} border ${value.borderColor} rounded-2xl p-6 hover:shadow-lg transition-all duration-300 group`}
            >
              <div className="flex items-start gap-4">
                <div className={`w-11 h-11 ${value.color} rounded-xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${value.icon} text-white text-lg`}></i>
                </div>
                <div className="flex-1 space-y-1.5">
                  <h3 className="text-base font-semibold text-[#0F1F3D] leading-snug">
                    {value.title}
                  </h3>
                  <p className="text-sm text-gray-700 leading-snug">
                    {value.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
